function myInitFunction() {
  var option3Value = window.option3Value;
  var currentHandle = window.currentHandle;
  var subscriptionProduct = window.subscriptionProduct;
  var defaultOneTimeSelect = window.defaultOneTimeSelect;
  const errorSpan = document.querySelector(".orichi-quantity-textError");

  if (
    option3Value &&
    subscriptionProduct &&
    currentHandle != "boobie-bar-free-sample-pack" &&
    currentHandle != "boobie-bar" &&
    currentHandle != "boobie-body" &&
    currentHandle != "lactation-oat-cookie-bites"
  ) {
    $(".one_time_variants, .pro_btn_area .one_time_pro").hide();
    $(".template-product .ontime_price").hide();
    $(".template-product .subscription_price_tub").show();
    $(".template-product .subscription_price").hide();
    //$('fieldset ul li[data-frequency="subscription-tub"]').addClass('active');
    //$('.pro_btn_area .one_time_pro[date_rel="subscription-tub"]').addClass('active');
  } else if (subscriptionProduct && defaultOneTimeSelect == "") {
    const priceElem = $(
      ".template-product .subscription_price span[data-price]",
    );

    if (
      currentHandle === "boobie-bar" ||
      currentHandle === "mother-of-all-greens" ||
      currentHandle === "lactation-oat-cookie-bites"
    ) {
      setTimeout(() => {
        const price = parseFloat(priceElem.text().replace("$", "").trim());
        let perUnitPrice, label;
        if (currentHandle === "boobie-bar") {
          const boxes = parseInt(priceElem.attr("data-boxes")) || 1;
          perUnitPrice = (price / boxes).toFixed(2);
          label = "/box";
        } else if (currentHandle === "mother-of-all-greens") {
          perUnitPrice = "32.00";
          label = "/30 servings";
        } else if (currentHandle === "lactation-oat-cookie-bites") {
          perUnitPrice = "12.00";
          label = "/bag";
        }

        $(".template-product .subscription_price #price-sub span").html(
          `$${perUnitPrice}<span class="ctm-perbox">${label}  </span>  `,
        );
        $(".template-product .subscription_price").show();
      }, 1000);
    } else {
      $(".template-product .subscription_price").show();
    }

    $(".pro_btn_area .one_time_pro").hide();
    //$('fieldset ul li[data-frequency="subscription"]').addClass('active');
    //$('.pro_btn_area .one_time_pro[date_rel="subscription"]').addClass('active');
  } else if (currentHandle == "boobie-body") {
    setTimeout(() => {
      const $wrap = $(".template-product .subscription_price"),
        $price = $wrap.find("span[data-price]"),
        perUnit = (
          parseFloat($price.text().replace("$", "")) /
          (+$price.data("boxes") || 1)
        ).toFixed(2);
      $wrap
        .find("#price-sub span")
        .html(`$${perUnit}<span class="ctm-perbox">/tub</span>`);
      $wrap.show();
    }, 500);

    $(".save-more-collape").removeClass("heightzero");
    $(".template-product .subscription_price").show();
    $(".pro_btn_area .one_time_pro").hide();
    //$('fieldset ul li[data-frequency="subscription"]').addClass('active');
    //$('.pro_btn_area .one_time_pro[date_rel="subscription"]').addClass('active');
  } else if (currentHandle == "boobie-bar") {
    setTimeout(function () {
      $(".template-product fieldset.bulk_and_save ul li.active").trigger(
        "click",
      );
    }, 1000);
  } else if (option3Value && currentHandle == "lactation-oat-cookie-bites") {
    setTimeout(function () {
      $(".template-product fieldset.bulk_and_save ul li.active").trigger(
        "click",
      );
    }, 1000);
  } else {
    $(".template-product .ontime_price").show();
    if (errorSpan) {
      setTimeout(function () {
        $(errorSpan.cloneNode(true)).insertBefore(
          $(".product__submit__buttons").first(),
        );
      }, 1500);
    }
  }

  $(".pro_bundle_and_save.pro_subscription_area.subscription").appendTo(
    ".bundle_product_button.sub-pro.subscription",
  );
  $(".pro_bundle_and_save.pro_subscription_area.subscription-tub").appendTo(
    ".bundle_product_button.sub-pro.subscription-tub",
  );

  $(document).on(
    "click",
    ".template-product fieldset.bulk_and_save ul li",
    function () {
      var $sellingInput = $(this)
        .closest(".recommended-box")
        .find('.radio__button:first input[name="selling_plan"] ~ label');
      if ($sellingInput.length) {
        $sellingInput.prop("checked", true).trigger("click");
      }

      var frequencySelected = $(this).attr("data-frequency");

      $("fieldset ul li").removeClass("active");
      $(this).addClass("active");

      $(".pro_btn_area .one_time_pro").each(function () {
        var select_option = $(this).attr("date_rel");

        if (frequencySelected == select_option) {
          $(".one_time_pro").removeClass("active");
          $(this).addClass("active");

          if (frequencySelected == "subscription") {
            $(".subscription_variants").show();
            $(".tub_subscription_variants").hide();
            $(".recm-collape").addClass("heightzero");
            $(".save-more-collape").removeClass("heightzero");
            $(".one_time_variants, .pro_btn_area .one_time_pro").hide();

            if (currentHandle === "boobie-bar") {
              const priceSubElement = $(
                ".template-product .subscription_price #price-sub",
              );

              if (!priceSubElement.find(".ctm-perbox").length) {
                const priceElement = $(
                  ".template-product .subscription_price span[data-price]",
                );
                const priceText = priceElement.text().replace("$", "").trim();
                const boxCount = parseInt(priceElement.attr("data-boxes")) || 1;

                const perUnitPrice = (parseFloat(priceText) / boxCount).toFixed(
                  2,
                );

                priceSubElement
                  .find("span")
                  .html(`$${perUnitPrice}<span class="ctm-perbox">/box</span>`);
              }
            }

            $(".template-product .subscription_price").show();
            $(".template-product .ontime_price").hide();

            $(".template-product .subscription_price_tub").hide();
            $(
              ".pro_bundle_and_save, .pro_subscription_area, .subscription-tub",
            ).hide();
          } else if (frequencySelected == "onetime") {
            $(".subscription_variants").hide();
            $(".tub_subscription_variants").hide();
            $(".recm-collape").addClass("heightzero");
            $(".save-more-collape").addClass("heightzero");
            $(".one_time_variants, .pro_btn_area .one_time_pro").show();
            $(".template-product .subscription_price").hide();
            $(".template-product .ontime_price").show();
            $(".ctm-hide").hide();
            $(".template-product .subscription_price_tub").hide();
            if (currentHandle === "boobie-bar") {
              if (
                !$(
                  ".template-product .ontime_price .product__price .product__price--sale .ctm-perbox",
                ).length
              ) {
                var perUnitPrice = (
                  parseFloat(
                    $(
                      ".template-product .ontime_price .product__price .product__price--sale",
                    )
                      .text()
                      .replace("$", "")
                      .trim(),
                  ) /
                    parseInt(
                      $(
                        ".template-product .ontime_price .product__price .product__price--sale",
                      ).attr("data-boxes"),
                    ) || 0
                ).toFixed(2);
                $(
                  ".template-product .ontime_price .product__price .product__price--sale",
                ).html(`$${perUnitPrice}<span class="ctm-perbox">/box</span>`);
              }
            }
            if (currentHandle === "boobie-bar-free-sample-pack") {
              $(".product__submit__buttons .select-popout button").hide();
              $(".product__submit__buttons").addClass("align-message");
            }
          } else if (frequencySelected == "subscription-tub") {
            $(".subscription_variants").hide();
            $(".tub_subscription_variants").show();
            $(".recm-collape").removeClass("heightzero");
            $(".save-more-collape").addClass("heightzero");
            $(".one_time_variants, .pro_btn_area .one_time_pro").hide();
            $(".template-product .subscription_price_tub").show();
            $(".template-product .ontime_price").hide();
            $(".template-product .subscription_price").hide();
            if (errorSpan) {
              $(errorSpan.cloneNode(true)).insertBefore(
                $(".product__submit").last(),
              );
            }
            // if (currentHandle === 'boobie-bar-free-sample-pack') {
            //     const price = parseFloat($('.subscription_price_tub span[data-price]').text().replace('$', '').trim()) || 0;

            //     if (!$('.template-product .subscription_price_tub span[data-price] .ctm-perbox').length) {
            //         const perUnitPrice = (price / 2).toFixed(2);
            //         $('.template-product .subscription_price_tub #price-sub span').html(`$${perUnitPrice}<span class="ctm-perbox">/box</span>`);
            //     }
            // }
          }
          if (currentHandle === "boobie-bar-free-sample-pack") {
            $(".product__submit__buttons .select-popout button").hide();
            $(".product__submit__buttons").addClass("align-message");
          }
        }
      });
    },
  );

  $(
    ".selector-wrapperss.option-frequence .radio__buttons span.radio__button",
  ).each(function () {
    var total_price = $(
      ".bundle_product_button.sub-pro .compare_sub_price",
    ).html();
    var main_price = $(
      ".bundle_product_button.sub-pro .current_sub_price",
    ).html();
    var option_tub_total_price = $(
      ".bundle_product_button.sub-pro #Product--product_subscription_save_feilds_option_tub_modal .compare_sub_price",
    ).html();
    var option_tub_main_price = $(
      ".bundle_product_button.sub-pro #Product--product_subscription_save_feilds_option_tub_modal .current_sub_price",
    ).html();

    $("#radiogroup-option-1 .price_area del").html(total_price);
    $("#radiogroup-option-2 .price_area del").html(option_tub_total_price);

    var productHandle = window.currentHandle;
    if (
      ["mother-of-all-greens", "hydromom", "boobie-bears"].includes(
        productHandle,
      )
    ) {
      let hasCalculated = false;
      let interval = setInterval(function () {
        let priceElementSpan = $("#price-sub span");
        if (
          priceElementSpan.length > 0 &&
          priceElementSpan.text().trim() &&
          !hasCalculated
        ) {
          let currentText = priceElementSpan.html().trim();
          let nprice = parseFloat(
            priceElementSpan.text().replace(/[$,]/g, "").trim(),
          );
          let dataBoxes = parseInt(priceElementSpan.attr("data-boxes"));

          if (
            !currentText.includes("/box") &&
            !currentText.includes("/jar") &&
            !currentText.includes("/bag") &&
            !currentText.includes("/bottle") &&
            !isNaN(nprice) &&
            dataBoxes > 0
          ) {
            let pricePerBox = (nprice / dataBoxes).toFixed(2);
            let suffix =
              productHandle === "mother-of-all-greens"
                ? "/jar"
                : productHandle === "boobie-bears"
                  ? "/bottle"
                  : "/bag";

            priceElementSpan.html(
              `$${pricePerBox}<span class="ctm-perbox">${suffix}</span>`,
            );
            hasCalculated = true;
            clearInterval(interval);
          } else if (
            isNaN(nprice) ||
            dataBoxes <= 0 ||
            currentText.includes("/box") ||
            currentText.includes("/jar") ||
            currentText.includes("/bottle")
          ) {
            clearInterval(interval);
          }
        }
      }, 100);
    }

    $(".subscription_price #price-sub > span").html(main_price);
    $(".subscription_price #price-sub > del").html(total_price);

    $(".subscription_price_tub #price-sub > span").html(option_tub_main_price);
    $(".subscription_price_tub #price-sub > del").html(option_tub_total_price);
  });

  var $modalWrapper = $("#Product--product_subscription_save_feilds_as_modal");
  var $buttonsBlock = $modalWrapper.find(
    ".product__block.product__block--buttons",
  );
  if ($modalWrapper.length && $buttonsBlock.length) {
    $buttonsBlock.insertAfter($modalWrapper);
    $modalWrapper.appendTo(".subscription_variants");
  }

  var $modalTubWrapper = $(
    "#Product--product_subscription_save_feilds_option_tub_modal",
  );
  var $buttonsTubBlock = $modalTubWrapper.find(
    ".product__block.product__block--buttons",
  );
  if ($modalTubWrapper.length && $buttonsTubBlock.length) {
    $buttonsTubBlock.insertAfter($modalTubWrapper);
    $modalTubWrapper.appendTo(".tub_subscription_variants");
  }
}

window.addEventListener("load", myInitFunction);

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".radio__buttons .radio__button");
  const buttonCount = buttons.length;

  if (buttonCount >= 4) {
    // Helper function to set width
    const setWidth = (index) => {
      if (buttons[index - 1]) {
        buttons[index - 1].style.width = "48.5%";
      }
    };

    setWidth(4);

    if (buttonCount >= 5) setWidth(5);
    if (buttonCount >= 7) setWidth(7);
    if (buttonCount === 10) setWidth(10);
  }
});

(function () {
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (response) => {
      if (
        response.url.includes("/cart/add") ||
        response.url.includes("/cart/change") ||
        response.url.includes("/cart/update") ||
        response.url.includes("/cart/clear")
      ) {
        const cartRes = await originalFetch(
          `${window.Shopify.routes.root}cart.js`,
        );
        const cart = await cartRes.json();

        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: { cartCount: cart.item_count },
          }),
        );
      }
      return response;
    });
  };
})();
